import ListItemIcon from "@mui/material/ListItemIcon";
import { MenuItemProps } from "@mui/material/MenuItem";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import OverflowText from "designSystem/components/text/OverflowText";
import Text from "designSystem/components/text/Text";
import React, { forwardRef, RefObject } from "react";
import { useLocale } from "designSystem/locale";
import { TooltipProps } from "../tooltip/Tooltip";
import MenuItem from "./MenuItem";

export interface MenuItemWithIconProps extends Omit<MenuItemProps, "button"> {
	/** the description of the item */
	description?: string;

	/** localization resource to use to lookup text; can be simple resource or type resource (i.e. "User.Name") */
	res?: string;

	/** parameters to pass if looking up resource */
	resParams?: Array<number | string>;

	/** the text of the item */
	text?: string;
	
	/** properties for tooltip */
	tooltipProps?: Partial<TooltipProps>;
}

const MenuItemWithIcon = forwardRef((props: MenuItemWithIconProps, ref: RefObject<HTMLLIElement>) => {
	const {
		children,
		description,
		res,
		resParams,
		text,
		tooltipProps,
		...otherProps
	} = props;

	const value = res ? useLocale()
		.resource(res, resParams) : text;

	return (
		<MenuItem
			ref={ref}
			style={{ width: "100%" }}
			{...otherProps}
		>
			<FlexRowCenter>
				<ListItemIcon style={{ marginRight: 8, minWidth: 20 }}>
					{children}
				</ListItemIcon>
				<div>
					<OverflowText text={value} tooltipProps={tooltipProps} />
					{description && <Text color="textSecondary" text={description} />}
				</div>
			</FlexRowCenter>
		</MenuItem>
	);
});

export default MenuItemWithIcon;